import { useContext } from 'react';

import { EnnismoreThemeContext } from '../ennismore-theme.context';

/**
 * This is preferrable to using Theme UI's hooks directly, as we can retain type safety for the theme object.
 */
export const useTheme = () => useContext(EnnismoreThemeContext);
